// Dynamically import all letter files in this folder (except index.js)
const req = require.context('./', false, /^(?!\.\/index\.js$).*\.js$/);
const letters = req.keys().map(key => req(key).default);

export default letters;
